// extracted by mini-css-extract-plugin
module.exports = {"gameScreen":"Game_gameScreen__3abbq","gameScreenWrapper":"Game_gameScreenWrapper__25juF"};